/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorDetail } from './ErrorDetail';
import { Resource } from './Resource';

export const ProblemMethodNotAllowedResourceDeleted: core.serialization.ObjectSchema<
    serializers.ProblemMethodNotAllowedResourceDeleted.Raw,
    Truvity.ProblemMethodNotAllowedResourceDeleted
> = core.serialization.object({
    actual: Resource,
    detail: core.serialization.string().optional(),
    errors: core.serialization.list(ErrorDetail).optional(),
    instance: core.serialization.string().optional(),
    status: core.serialization.number(),
    title: core.serialization.string(),
});

export declare namespace ProblemMethodNotAllowedResourceDeleted {
    export interface Raw {
        actual: Resource.Raw;
        detail?: string | null;
        errors?: ErrorDetail.Raw[] | null;
        instance?: string | null;
        status: number;
        title: string;
    }
}
